"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = void 0;
const crypto_1 = require("crypto");
const BaseLogger_1 = require("./BaseLogger");
class Entity extends BaseLogger_1.BaseLogger {
    props;
    constructor(props) {
        super();
        this.props = props;
    }
    get id() {
        return this.props.id;
    }
    static generateId() {
        return (0, crypto_1.randomUUID)();
    }
    equals(other) {
        return this.id === other.id;
    }
    toPrimitives() {
        return { ...this.props };
    }
    getLogPayload() {
        return {
            id: this.id,
            props: this.props,
        };
    }
    getLogType() {
        return 'entity';
    }
}
exports.Entity = Entity;
